import React from "react";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import logo from "../../../assets/images/sbs/Logo-Say-What.png";
import { connect, useSelector } from "react-redux";
import { Button } from "reactstrap";

const Voting = ({ captionsArray, onTimesUp, ...props }) => {
  const captionImage = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state?.photo
  );

  return (
    <>
      <div className="vote-container">
        <div className="vote text-center">
          <img src={logo} className="say-what-logo" alt="logo" />
          <h2 className="vote-text">Vote for your favorite</h2>
          <img src={captionImage} className="vote-img" alt="caption" />

          <div className="voter-list-wrap">
            <div className="voter-list">
              {captionsArray &&
                captionsArray.length > 0 &&
                captionsArray?.map((user) => (
                  <div className="voter-card">
                    <p>{user.caption}</p>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <Button onClick={() => onTimesUp()} className="done-btn">
          Everyone’s Done
        </Button>
      </div>{" "}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withRouter, connect(mapStateToProps))(Voting);
